import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

/**
 * A scroll-anchored, collapsible section wrapper. Expanded by default; the
 * chevron in the header toggles the body. `id` is the scroll target used by the
 * left nav rail and scroll-spy; `innerRef` is forwarded so the parent can
 * observe the section for active-state tracking.
 */
class SectionBlock extends React.Component {
    state = { expanded: true };

    // Controlled when an `expanded` prop is supplied; otherwise self-managed.
    isExpanded() {
        return this.props.expanded !== undefined
            ? this.props.expanded
            : this.state.expanded;
    }

    toggle = () => {
        if (this.props.onToggle) {
            this.props.onToggle();
        } else {
            this.setState(prev => ({ expanded: !prev.expanded }));
        }
    };

    render() {
        const { id, title, subtitle, icon, innerRef, extra, children } = this.props;
        const expanded = this.isExpanded();
        return (
            <section
                id={id}
                ref={innerRef}
                className={
                    "credit-checker-section" +
                    (expanded ? "" : " credit-checker-section--collapsed")
                }
            >
                <header className={"credit-checker-section__header"}>
                    <button
                        type={"button"}
                        className={"credit-checker-section__heading"}
                        onClick={this.toggle}
                        aria-expanded={expanded}
                    >
                        <span className={"credit-checker-section__chevron"}>
                            <Icon type={expanded ? "down" : "right"} />
                        </span>
                        {icon ? (
                            <span className={"credit-checker-section__icon"}>
                                <Icon type={icon} />
                            </span>
                        ) : null}
                        <span className={"credit-checker-section__titles"}>
                            <span className={"credit-checker-section__title"}>
                                {title}
                            </span>
                            {/* Section subtitles suppressed per credit-team
                                request — one-line headers only. Prop is still
                                accepted for back-compat but never rendered. */}
                        </span>
                    </button>
                    {extra ? (
                        <div className={"credit-checker-section__extra"}>
                            {extra}
                        </div>
                    ) : null}
                </header>
                {expanded ? (
                    <div className={"credit-checker-section__body"}>
                        {children}
                    </div>
                ) : null}
            </section>
        );
    }
}

SectionBlock.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    icon: PropTypes.string,
    innerRef: PropTypes.object,
    extra: PropTypes.node,
    expanded: PropTypes.bool,
    onToggle: PropTypes.func,
    children: PropTypes.node
};

export default SectionBlock;
